/* eslint-disable no-undef */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import MapService from '../shared/map-service';
import { scaledIcon, resolveMarkerSizes, isNearAnyPoint } from '../shared/map-marker-icons';
import Arrival from '../_styles/images/Arrival.svg';
import Destination from '../_styles/images/StartVector.svg';
import StopMarker from '../_styles/images/StopMarker.svg';
import CancelledStop from '../_styles/images/new-icons/CancelledStop.svg';
import End from '../_styles/images/End.svg';

const controlsOff = {
  zoomControl: false,
  mapTypeControl: false,
  scaleControl: false,
  streetViewControl: false,
  rotateControl: false,
  fullscreenControl: false
};

const buildRouteMarkers = (directions, cancelledPoints = [], markerSizes = {}) => {
  const legs = directions && directions.routes && directions.routes[0] && directions.routes[0].legs;
  if (!legs || legs.length === 0) {
    return [];
  }

  const sizes = resolveMarkerSizes(markerSizes);
  const start = legs[0].start_location;
  const end = legs[legs.length - 1].end_location;
  // Cancelled stops don't consume a letter, so labels run A, B, C over active stops only.
  let activeStopCount = 0;
  const waypointMarkers = legs.slice(0, -1).map(leg => {
    const lat = leg.end_location.lat();
    const lng = leg.end_location.lng();

    if (isNearAnyPoint(lat, lng, cancelledPoints)) {
      return { lat, lng, icon: scaledIcon(CancelledStop, sizes.cancelled, true) };
    }

    const index = activeStopCount++;

    return {
      lat,
      lng,
      icon: scaledIcon(StopMarker, sizes.stop, true),
      label: {
        text: String.fromCharCode('A'.charCodeAt(0) + index),
        color: '#393A3B',
        fontWeight: '700',
        fontSize: '14px'
      }
    };
  });

  return [
    {
      lat: start.lat(),
      lng: start.lng(),
      icon: scaledIcon(Destination, sizes.start)
    },
    ...waypointMarkers,
    { lat: end.lat(), lng: end.lng(), icon: scaledIcon(End, sizes.end) }
  ];
};

class RouteMap extends Component {
  constructor(props) {
    super(props);
    this.state = { ready: false, cancelledPoints: [] };
  }

  onLoad() {
    if (!this.state.ready && this.map) {
      this.setState({ ...this.state, ready: true });
      if (this.props.padding) {
        setTimeout(
          () =>
            this.map &&
            this.map.fitBounds(this.map.getBounds(), this.props.padding),
          200
        );
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.cancelledDirections && props.cancelledDirections.length > 0) {
      const cancelledStops = props.cancelledDirections.map(dir => ({
        lat: dir.latitude,
        lng: dir.longitude
      }));
      return { ...state, cancelledPoints: cancelledStops };
    }
    return { ...state, cancelledPoints: [] };
  }

  shouldComponentUpdate(props) {
    if (!this.state.ready) {
      return true;
    }

    if (!this.props.directions && !this.props.todaysDirections) {
      return true;
    } else if (this.props.directions) {
      if (
        this.props.directions.geocoded_waypoints && this.props.directions.geocoded_waypoints.length !==
        props.directions.geocoded_waypoints.length
      ) {
        return true;
      }

      return this.props.directions.geocoded_waypoints.some((waypoint, i) => {
        const newWaypoint = props.directions.geocoded_waypoints[i];
        return newWaypoint.place_id !== waypoint.place_id;
      });
    } else if (this.props.todaysDirections) {
      if (
        this.props.todaysDirections.geocoded_waypoints && this.props.todaysDirections.geocoded_waypoints.length !==
        props.todaysDirections.geocoded_waypoints.length
      ) {
        return true;
      }

      return this.props.todaysDirections.geocoded_waypoints.some((waypoint, i) => {
        const newWaypoint = props.todaysDirections.geocoded_waypoints[i];
        return newWaypoint.place_id !== waypoint.place_id;
      });
    }
  }

  render() {
    const { directions, controls = true, isToday = false, todaysDirections, isCustomMarkers, markerSizes } = this.props;
    const { ready, cancelledPoints } = this.state;
    const activeDirections = isToday ? todaysDirections : directions;
    const markers = isCustomMarkers
      ? buildRouteMarkers(activeDirections, cancelledPoints, markerSizes)
      : undefined;

    return (
      <div className={`google-map ${ready ? 'ready' : ''}`}>
            <MapService.MapWithDirections
              directions={activeDirections}
              markers={markers}
              options={!controls ? controlsOff : null}
              mapRef={map => (this.map = map)}
              onTilesLoaded={() => this.onLoad()}
              hideTitle={true}
            />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    directions: state.map.googleDirections,
    todaysDirections: state.map.todaysGoogleDirections,
    cancelledDirections: state.map.cancelledDirections
  };
}

export default connect(mapStateToProps)(RouteMap);
